<app-sidebar2 *ngIf="!(hideSidebar | async)"></app-sidebar2>

<div
  [class.main-content]="!whiteLabelService.getI('sidebar.hidden') && !(hideSidebar | async)"
  [class.sidebar-hidden]="hideSidebar"
  [class.sidebarExpanded]="sidebarExpanded"
  [class.sidebar-hidden-mobile]="sidebarHiddenMobile"
>
  <div
    class="container-fluid"
    [class.wrapper]="!(isSDK | async)"
    [class.pt-5]="!(isSDK | async) && (isTrial$ | async) !== true"
    [class.pb-6]="!(isSDK | async)"
    [class.wrapper-wide]="wrapperWide"
  >
    <div class="row">
      <div class="col main">
        <app-subscription-expiration-banner></app-subscription-expiration-banner>

        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
